import React, { PropsWithChildren } from "react";

import { TestProps, TestWrapper } from "@ui/Atoms";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Service.styled";

export const Service: React.FC<
  PropsWithChildren<
    {
      title: string;
      cta: string;
      href: string;
      isComingSoon: boolean;
    } & TestProps
  >
> = ({ children, title, cta, href, isComingSoon, testId }) => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <TestWrapper testId={testId}>
      <Styled.Root>
        <Styled.ImageWrapper>
          {children}
          {isComingSoon && <Styled.OpacityOverlay />}
        </Styled.ImageWrapper>
        <Styled.TextWrapper>
          <Styled.Title>{title}</Styled.Title>
          {!isComingSoon && <Styled.Cta>{cta}</Styled.Cta>}
        </Styled.TextWrapper>
        {!isComingSoon && <Styled.AnchorOverlay href={href} />}
        {isComingSoon && (
          <Styled.Label>{translate("coming_soon_label")}</Styled.Label>
        )}
      </Styled.Root>
    </TestWrapper>
  );
};
